// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as TbConsts from "./TbConsts.bs.js";
import * as ReactDnd from "react-dnd";

function TbHexWrap(Props) {
  var hexSize = Props.hexSize;
  var xGridSize = Props.xGridSize;
  var yGridSize = Props.yGridSize;
  var extended = Props.extended;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onDrop = Props.onDrop;
  var onMove = Props.onMove;
  var onDropItem = Props.onDropItem;
  var onMoveItem = Props.onMoveItem;
  var isEmpty = Props.isEmpty;
  var highlight = Props.highlight;
  var children = Props.children;
  var match = Jotai.useAtom(TbAtoms.compactMode);
  var compactMode = match[0];
  var hexSize$1 = compactMode ? hexSize + 1 : hexSize;
  var match$1 = ReactDnd.useDrop({
        accept: [
          "unit",
          "hex",
          "item",
          "hex-item"
        ],
        drop: (function (item) {
            if (item.type === "unit") {
              Curry._3(onDrop, colNum, rowNum, item.id);
            } else if (item.type === "hex") {
              Curry._2(onMove, [
                    item.colNum,
                    item.rowNum
                  ], [
                    colNum,
                    rowNum
                  ]);
            } else if (item.type === "item") {
              Curry._3(onDropItem, [
                    colNum,
                    rowNum
                  ], item.itemId, item.shadow);
            } else if (item.type === "hex-item") {
              Curry._3(onMoveItem, [
                    item.colNum,
                    item.rowNum
                  ], [
                    colNum,
                    rowNum
                  ], item.idx);
            }
            
          }),
        canDrop: (function (item, _monitor) {
            return !((item.type === "item" || item.type === "hex-item") && isEmpty && item.id !== "TFT12_Yuumi");
          }),
        collect: (function (monitor) {
            return {
                    isOver: monitor.isOver({
                          shallow: true
                        }) && monitor.canDrop()
                  };
          })
      });
  return React.createElement("g", {
              ref: match$1[1],
              transform: compactMode ? "translate(" + String(Math.imul(colNum, xGridSize) + Math.imul((rowNum + 1 | 0) % 2, xGridSize / 2 | 0) | 0) + "," + String((((
                          extended ? 740 : 390
                        ) - 136 | 0) - Math.imul(rowNum, yGridSize - 12 | 0) | 0) + (
                      rowNum > 3 ? -14 : 0
                    ) | 0) + ")" : "translate(" + String(Math.imul(colNum, xGridSize) + Math.imul((rowNum + 1 | 0) % 2, xGridSize / 2 | 0) | 0) + "," + String(((
                        extended ? TbConsts.heightXlFull - (yGridSize + (yGridSize / 3 | 0) | 0) | 0 : TbConsts.heightXl - (yGridSize + (yGridSize / 3 | 0) | 0) | 0
                      ) - Math.imul(rowNum, yGridSize) | 0) + (
                      rowNum > 3 ? -16 : 0
                    ) | 0) + ")"
            }, React.createElement("path", {
                  d: T.genHexPath(hexSize$1 + 6),
                  fill: "transparent",
                  transform: "translate(-5.5, -6)"
                }), React.createElement("path", {
                  d: T.genHexPath(hexSize$1),
                  fill: "rgba(0, 0, 0, 0.6)"
                }), highlight !== undefined ? React.createElement("path", {
                    className: "pointer-events-none",
                    d: T.genHexPath(hexSize$1 + 3.5),
                    fill: "transparent",
                    filter: "url(#blurMe)",
                    stroke: highlight,
                    strokeWidth: "2.75",
                    transform: "translate(-2.75, -3.75)"
                  }) : null, children, match$1[0].isOver ? React.createElement("path", {
                    d: T.genHexPath(hexSize$1),
                    fill: "transparent",
                    filter: "url(#blurMe)",
                    stroke: "#" + Colors.teal200
                  }) : null);
}

var make = TbHexWrap;

export {
  make ,
  
}
/* T Not a pure module */
